import { render } from "./header01.vue?vue&type=template&id=36877f38&scoped=true"
import script from "./header01.vue?vue&type=script&lang=js"
export * from "./header01.vue?vue&type=script&lang=js"

import "./header01.vue?vue&type=style&index=0&id=36877f38&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36877f38"]])

export default __exports__